
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { formatDistanceToNow } from "date-fns";

export interface CommentType {
  id: string;
  author: string;
  authorInitials: string;
  authorImage?: string;
  content: string;
  createdAt: Date;
}

interface CommentProps {
  comment: CommentType;
}

const Comment = ({ comment }: CommentProps) => {
  return (
    <div className="py-4 border-b">
      <div className="flex items-start gap-4">
        <Avatar>
          {comment.authorImage && <AvatarImage src={comment.authorImage} alt={comment.author} />}
          <AvatarFallback>{comment.authorInitials}</AvatarFallback>
        </Avatar>
        
        <div className="flex-1">
          <div className="flex items-baseline justify-between mb-1">
            <h4 className="font-medium">{comment.author}</h4>
            <span className="text-xs text-muted-foreground">
              {formatDistanceToNow(comment.createdAt, { addSuffix: true })}
            </span>
          </div>
          <p className="text-sm">{comment.content}</p>
        </div>
      </div>
    </div>
  );
};

export default Comment;
